import React from "react";
import Content from "Pages/Content";


const Contenttheme = () => {
  return (
    <React.Fragment>
       <Content/>
    </React.Fragment>
  );
};

export default Contenttheme;
